export default __webpack_public_path__ + "images/038d2643f261682039c25bbfbbdff71d.svg";